import { GTMEventDataMapping } from '@corratech/pylot-gtm/src/GTM'

const CHECKOUT_STEPS = {
    SHIPPING_ADDRESS_SELECTED: 0,
    SHIPPING_METHOD_SELECTED: 1,
    PAYMENT_METHOD_SELECTED: 2
}

const getGtmMappingOverrides = (): GTMEventDataMapping => ({
    PLACE_ORDER: {
        productsDetails: {
            data_source: ['productsDetails'],
            mapping: {
                id: ['product', 'uid'],
                name: ['product', 'name'],
                quantity: ['product', 'quantity'],
                price: ['product', 'price'],
                category: ['product', 'category'],
                brand: ['product', 'brand']
            },
            strict: true
        }
    }
})

export { CHECKOUT_STEPS, getGtmMappingOverrides }
